// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveUserDefaultResponse {
    static getAttributeTypeMap() {
        return AccountSaveUserDefaultResponse.attributeTypeMap;
    }
}
AccountSaveUserDefaultResponse.discriminator = undefined;
AccountSaveUserDefaultResponse.additionalProperties = false;
AccountSaveUserDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "string"
    },
];
//# sourceMappingURL=accountSaveUserDefaultResponse.js.map